/* eslint-disable react/no-children-prop */
import React from 'react';
import { useColorModeValue } from '@chakra-ui/react';
import Select from 'react-select';

export const SelectFilter = ({
  onChange,
  placeholder,
  options,
  setValue,
  isSearchable,
  isDisabled: isSelectDisabled,
  onInputChange,
  value,
  ...rest
}: any) => {
  const customStyles = {
    menu: (provided, state) => ({
      ...provided,
      zIndex: 9999,
      width: '100%',
      maxWidth: '350px',
      color: state.selectProps.menuColor,
    }),
    control: (styles, { isDisabled }) => {
      return {
        ...styles,
        boxShadow: '0px 2px 4px #00000050',
        opacity: isDisabled ? 0.7 : 1,
        backgroundColor: '#FAFAFA',
        height: '2.5em',
        borderColor: 'inherit',
        width: '100%',
        maxWidth: '350px',
        // borderRadius: '500px',
      };
    },
    option: (provided, state) => ({
      ...provided,
      borderBottom: '1px solid grey.100',
      borderRadius: '5px',
      padding: '10px 24px',
      background: state.isSelected
        ? useColorModeValue('theme.light.redInterm', 'theme.dark.redInterm')
        : useColorModeValue('theme.light.body', 'theme.dark.body'),
    }),
    singleValue: (provided, { isDisabled }) => {
      const opacity = isDisabled ? 0.7 : 1;
      const transition = 'opacity 300ms';

      return { ...provided, opacity, transition };
    },
  };

  return (
    <Select
      options={options}
      placeholder={placeholder}
      noOptionsMessage={() => 'Nenhum resultado encontrado'}
      onChange={(option: any) => {
        onChange(option?.value);
        if (setValue) {
          setValue(option?.value);
        }
      }}
      isClearable
      isDisabled={isSelectDisabled}
      isSearchable={isSearchable}
      onInputChange={onInputChange}
      value={options?.find((option: any) => option.value === value) ?? null}
      styles={customStyles}
      {...rest}
    />
  );
};
